import { GlobalsContext } from "shared/constants";
import { Globals } from "shared/types";

function GlobalsProvider({
  children,
  ...props
}: React.PropsWithChildren<Globals>) {
  return (
    <GlobalsContext.Provider value={props}>{children}</GlobalsContext.Provider>
  );
}

export default GlobalsProvider;
